import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,_vm._g(_vm._b({staticClass:"text-uppercase",attrs:{"icon":false,"fab":false,"color":_vm.color}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_vm._t("default"),(_vm.appendIcon)?_c(VIcon,{attrs:{"right":"","dark":""}},[_vm._v(_vm._s(_vm.appendIcon))]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }